import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  StyledForm,
  StyledInput,
  SubmitButton,
  ErrorMessage,
  StyledImage,
  StyledComment,
  ForgotPasswordLink,
  InputWrapper,
  EyeStyled
} from '../styled';
import { BASE_URL } from '../../../environment/environment';
import logo from '../../../images/logo.png';
import { ForgotPasswordForm } from '../ForgotPaswordForm.js';
import { Eye, EyeOff } from 'lucide-react';

export const LoginForm = ({ email }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/Auth/login`, { email, password }, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        localStorage.setItem('access_token', response.data.token);
        navigate('/jira-issue');
      } else {
        setError(response.data.message || 'Błąd logowania');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Błąd logowania, spróbuj ponownie');
    } finally {
      setLoading(false);
    }
  };

  if (isResetPassword) {
    return <ForgotPasswordForm email={email} />;
  }

  return (
    <StyledForm onSubmit={handleLogin}>
      <StyledImage src={logo} alt="Logo" />
      <StyledComment>Zaloguj się:</StyledComment>
      <StyledInput
        type="email"
        placeholder="E-mail"
        value={email}
        required
        readOnly
      />
      <InputWrapper>
        <StyledInput
          type={showPassword ? "text" : "password"}
          placeholder="Hasło"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
        />
        <EyeStyled onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <EyeOff size={24} /> : <Eye size={24} />}
        </EyeStyled>
      </InputWrapper>
      <ForgotPasswordLink onClick={() => setIsResetPassword(true)}>
        Nie pamiętasz hasła?
      </ForgotPasswordLink>
      <SubmitButton type="submit" disabled={loading || !email || !password}>
        {loading ? 'Logowanie...' : 'Zaloguj się'}
      </SubmitButton>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </StyledForm>
  );
};
